<template>
  <component :is="layout">
    <transition mode="out-in">
      <router-view v-if="serviceAvailable" @layout="layout = $event" />
      <service-unavailable v-else />
    </transition>
  </component>
</template>

<script>
import ServiceUnavailable from '@/components/ServiceUnavailable'

export default {
  components: { ServiceUnavailable },
  data() {
    return {
      layout: 'div',
    }
  },
  computed: {
    serviceAvailable() {
      return this.$store.state.service.available
    },
    enableSeasonFeature() {
      return this.$store.state.preferences.enableSeasonFeature
    },
  },
  watch: {
    serviceAvailable(available) {
      if (!available) {
        this.layout = 'div'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// Router Transition Animation
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
